module.exports = __webpack_public_path__ + "static/media/YB5F03_3.54a60d0b.jpg";